// GoogleLoginHandler.tsx
import React, { FC } from 'react';
import { FcGoogle } from "react-icons/fc";
import ProviderButton from '../providerButtons';
import { appConfig } from '@common/config/app.config';
import { GoogleLogin, GoogleOAuthProvider } from '@react-oauth/google';

interface GoogleLoginHandlerProps {
  onLoginSuccess: (credential: string) => void;
  onLoginError: () => void;
  isExtension: boolean;
  googleLoading?: boolean;
}

const GoogleLoginHandler: FC<GoogleLoginHandlerProps> = ({ onLoginSuccess, onLoginError, isExtension,googleLoading }) => {

  if (isExtension) {
    return (
      <ProviderButton
        value="Signin with Google"
        clickHandler={(e) => {
          console.log('google clickHandler onSuccess');
          e.preventDefault();
          onLoginSuccess('');
        }}
        ProviderIcon={FcGoogle}
        loading={googleLoading}
      />
    );
  } else {
    return (
      <GoogleOAuthProvider clientId={appConfig.google_client_id}>
        <GoogleLogin
          onSuccess={credentialResponse => {
            console.log('GoogleOAuthProvider Login onSuccess');
            onLoginSuccess(credentialResponse.credential ?? '');
          }}
          onError={() => {
            console.log('GoogleOAuthProvider Login Failed');
            onLoginError();
          }}
          useOneTap
        />
      </GoogleOAuthProvider>
    );
  }
};

export default GoogleLoginHandler;
